const TileSize = {
    Default: 512,
    Small: 256,
    Medium: 512,
};

Object.freeze(TileSize);

export default TileSize;